import React from 'react';

import { SvgFilter } from '../../icons';
import { Button } from '../ui/button2';

export function FiltersButton({ onPress }: { onPress: () => void }) {
  return (
    <Button variant="bare" onClick={onPress}>
      <SvgFilter
        style={{ width: 12, height: 12, marginRight: 5, flexShrink: 0 }}
      />{' '}
      Filter
    </Button>
  );
}
